var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"background-promo",class:_vm.getPromoClass},[_c('div',{staticClass:"form",class:_vm.getClass},[_c('div',{staticClass:"center row",style:(_vm.getStyle)},[_c(_vm.getPromo,{tag:"component"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }